<template>
  <div class = "container">
    <Loader v-if = "isTextLoadInProgress"></Loader>
    <div v-else class = "main-form">
      <div class = "form">
        <div class = "form__row">
          <div class = "multiple-inputs-wrap">
            <div class = "form__input-box form__input-box--small">
              <label class = "form__label">Locale</label>
              <select class = "form__select"
                      v-model = "selectedLocaleValue"
                      @change = "selectTextForLocale">
                <option :key = "loc.value" :value = "loc.value" v-for = "(loc) in locales">{{loc.name}}</option>
              </select>
            </div>
            <div class = "form__input-box form__input-box--small">
              <label class = "form__label">Filter text keys</label>
              <FilterInput
                title = "Filter either by key or description"
                :filterList = "this.textKeys"
                :filterByKey = "filterFields"
                v-on:filter = "onTextKeysFilter"
              />
            </div>
          </div>
        </div>

        <div class = "arena-text-container">
          <ArenaTextEditBlock
            v-for = "(keyItem) in filteredTextKeys"
            v-bind:key = "keyItem.key"
            v-model = "arenaText[keyItem.key]"
            :global-text = "globalText[keyItem.key]"
            :title = "keyItem.key"
            :key-description = "keyItem.description"
          />
        </div>

        <div class = "form__row">
          <div class = "btns-row__right-btns">
            <button v-if = "$checkRoles(['Administrator'])"
                    class = "ark-btn ark-btn--default"
                    @click = "saveArenaTextData()">
              <Loader v-if = "isTextSaveInProgress"></Loader>
              <span v-else>Save Arena Text</span>
            </button>
          </div>
        </div>

      </div>
    </div>

    <InfoModal
      v-if = "arenaIsEdited"
      :msg = "'Arena text was successfully edited.'"
      :onCloseModal = "closeInfoModal"
    ></InfoModal>
  </div>
</template>

<script>
  import config from '../../../config'
  import Loader from '../../Loader/Loader.vue'
  import InfoModal from '../../InfoModal/InfoModal.vue'
  import ArenaTextEditBlock from './ArenaTextEditBlock.vue'
  import FilterInput from '../../FilterInput/FilterInput.vue'
  import { locales } from '../../../constants/locales'

  export default {
    components: {Loader, InfoModal, ArenaTextEditBlock, FilterInput},
    name: 'ArenaTextEditForm',
    props: ['selectedArena', 'globalTextAllLocales'],
    data () {
      return {
        textKeys: [], // [{key, description}]
        filterFields: ['key', 'description'],
        filteredTextKeys: [], // [{key, description}]
        locales: locales,
        selectedLocaleValue: locales[0].value,
        arenaText: null,
        globalText: null,
        isTextLoadInProgress: false,
        isTextSaveInProgress: false,
        arenaIsEdited: false // arena edited success flag
      }
    },
    created: function () {
      this.textKeys = Object.keys(this.globalTextAllLocales.settings).map((key) => {
        return {key, description: this.globalTextAllLocales.settings[key].description}
      })
      this.filteredTextKeys = this.textKeys
      this.getArenaTextData()
    },
    watch: {
      selectedArena: function (newValue, oldValue) {
        this.getArenaTextData()
      }
    },
    methods: {
      closeInfoModal: function () {
        this.arenaIsEdited = false
      },
      getArenaTextData: function () {
        this.isTextLoadInProgress = true
        let arenaTextPromise = this.$http.get(`${config.apiUrl}/arena/override/text/get?arenaDomain=${this.selectedArena.domain.replace('www.', '')}`)
        Promise.all([arenaTextPromise])
          .then(([arenaTextResponse]) => {
            this.arenaTextAllLocales = arenaTextResponse.body
            this.selectTextForLocale()
            this.isTextLoadInProgress = false
          }, error => {
            console.log(error)
            this.isTextLoadInProgress = false
          })
      },
      saveArenaTextData: function () {
        this.isTextSaveInProgress = true
        let url = `${config.apiUrl}/arena/override/text/save?arenaDomain=${this.selectedArena.domain}`

        this.$http.post(url, this.arenaTextAllLocales)
          .then(response => {
            this.isTextSaveInProgress = false
            this.arenaIsEdited = true
          }, error => {
            console.log(error)
            this.isTextSaveInProgress = false
          })
      },
      selectTextForLocale: function () {
        this.globalText = this.globalTextAllLocales.values.find(item => {
          return item.locale === this.selectedLocaleValue
        }).value

        this.arenaText = this.arenaTextAllLocales.find(item => {
          return item.locale === this.selectedLocaleValue
        }).value
      },
      onTextKeysFilter (textKeys) {
        this.filteredTextKeys = textKeys
      }
    }
  }
</script>

<style scoped lang = "scss" src = "./ArenaTextEditForm.scss"></style>
